// IMPORT LIBS
import jQuery from 'jquery';
import { redirectPage } from './functions/redirectPage';


window.$ = jQuery;
window.jQuery = jQuery;


// FUNCTION TO REDIRECT TO HOME PAGE
redirectPage();